<template>
  <div class="page-box">
    <el-form :model="form" ref="form" :rules="rules" label-width="auto" :inline="false">
      <el-form-item label="当前组别分类:" prop="currGroupClassifyId">
        <el-select v-model="form.currGroupClassifyId" placeholder="请选择" style="width:100%;" clearable @change="changeCurr">
          <el-option v-for="item in groupClassList" :key="item.id" :label="item.classifyName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="禁报组别分类:" prop="list">
        <el-select v-model="form.list" placeholder="请选择" multiple collapse-tags style="width:100%;" clearable
          :disabled="!form.currGroupClassifyId">
          <el-option v-for="item in ungroupClassList" :disabled="form.currGroupClassifyId == item.id" :key="item.id"
            :label="item.classifyName" :value="item.id">
          </el-option>
        </el-select>
        <div style="font-size: 12px;color:#AAAAAA;">{{ form.list.length == 0 ? '' : getListStr() }}</div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mqueryDropdownSelectGroupClassifies, saveMutualExclusionRule } from '../../../../../api/mymatchs/groupsetitem';

export default {
  name: "add-group-type",
  data() {
    return {
      form: {
        currGroupClassifyId: "",
        list: [],
      },
      rules: {
        currGroupClassifyId: [{ required: true, message: "请选择组别分类", trigger: "blur" }],
        list: [{ required: true, message: "请选择禁止组别分类", trigger: "blur" }],
      },
      groupClassList: [],
      ungroupClassList: [],
      matchId: '',
      groupNames:[], // 已经选择的组别分类名称数组
      ungroupNames:[], // 已经关联了的
      allGroupList:[]
    };
  },
  created() {
    const { matchId } = this.$attrs.params;
    if (matchId) {
      this.matchId = matchId;
      this.handlerTableData();
      this.getOption();
    }
  },
  methods: {
    handlerTableData() {
      if(this.$attrs.params.tableData){
        this.groupNames = this.$attrs.params.tableData.map(item => item.currGroupClassifyName); // 已经选择的组别分类名称数组
      }
    },
    changeCurr(val){
      const currGroupItem = this.allGroupList.find(item => item.id == val);
      this.$set(this.form, 'list', []);
      if(currGroupItem){
        let unGroupNames = this.$attrs.params.tableData.map(item => {
          if(item.mutualExclusionGroupClassifyName && item.mutualExclusionGroupClassifyName.split(',').includes(currGroupItem.classifyName)){
            return item.currGroupClassifyName
          }
        }).filter(item => item);
        unGroupNames.push(currGroupItem.classifyName);
        if(unGroupNames){
          unGroupNames = new Set(unGroupNames);
          this.ungroupClassList = this.allGroupList.filter(item => !unGroupNames.has(item.classifyName)); // 已经关联了的
        }
      }
    },
    async getOption() {
      const params = {
        matchId: this.matchId,
      }
      const res = await mqueryDropdownSelectGroupClassifies(params);
      if (res && res.status == 200) {
        this.allGroupList = res.data;
        this.groupClassList = res.data.map(item => {
          if(!this.groupNames.includes(item.classifyName)){
            return item;
          }
        }).filter(item => item);
      } else {
        res && res.msg && this.$message.error(res.msg);
      }
    },
    confirm(callback, close) {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const params = {
            matchId: this.matchId,
            currGroupClassifyId: this.form.currGroupClassifyId,
            list: this.form.list
          }
          const res = await saveMutualExclusionRule(params);
          if (res && res.status == 200) {
            this.$message.success("保存成功");
            callback();
            close && close();
          } else {
            res && res.msg && this.$message.error(res.msg);
          }
        } else {
          return false;
        }
      });

    },
    getListStr() {
      if (this.form.list.length > 0) {
        return this.form.list.map(item => {
          return this.ungroupClassList.find(it => it.id == item).classifyName;
        }).join('、')
      } else {
        return ''
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.page-box {
  padding: 15px;
}
</style>
